import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { TrackingRow } from "./TrackingRow";

function TrackingFormComponent(props) {
  const { formikProps, initialValues, setInitialValues } = props;
  const [ tracking, setTracking ] = useState(1);

  let trackingElements = [];

  for (let i = 1; i <= tracking; i++) {
    trackingElements.push(
      <TrackingRow
        key={ i }
        index={ i }
        tracking={ tracking }
        setTracking={ setTracking }
        formikProps={ formikProps }
        initialValues={ initialValues }
        setInitialValues={ setInitialValues }
      />
    );
  }

  return <div className="create-campaign-tracking-list">{ trackingElements }</div>;
}

const TrackingForm = injectIntl(TrackingFormComponent)

export { TrackingForm, TrackingFormComponent }
